module.exports = __webpack_public_path__ + "img/yibao.4ddd8c31.png";